export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_USER = "GET_USER";

export const CHANGE_THEME = "CHANGE_THEME";
export const NAV_THEME = "NAV_THEME";

export const ADD_CARD = "ADD_CARD";
export const UPDATE_CARD = "UPDATE_CARD";
export const DELETE_CARD = "DELETE_CARD";
export const GET_CARD = "GET_CARD";

export const ADD_BILLING_USER = "ADD_BILLING_USER";
export const UPDATE_BILLING_USER = "UPDATE_BILLING_USER";
export const DELETE_BILLING_USER = "DELETE_BILLING_USER";
export const GET_BILLING_USER = "GET_BILLING_USER";

export const CHANGE = "CHANGE";
export const NAVBAR_CHANGE = "NAVBAR_CHANGE";
export const NAVBAR_CLOSE = "NAVBAR_CLOSE";
